import { TooltipContentProps } from 'recharts';
import { ChartTooltipV2 } from '@Components/Charts/ChartTooltip/ChartTooltipV2';

// Recharts clones this with the hovered week's payload; values are clearance percentages.
export const ClearanceTooltip = ({
  active,
  payload,
  label
}: Partial<TooltipContentProps<number, string>>) =>
  active && payload?.length ? (
    <ChartTooltipV2
      headers={[String(label)]}
      items={payload.map(({ name, value, color, dataKey }) => ({
        label: name,
        value: `${value}%`,
        color,
        keyShape: dataKey === 'Actual' ? 'square' : 'line'
      }))}
    />
  ) : null;
